import React from 'react';
import classNames from 'classnames';
import style from './App.less';

import { injectIntl } from 'react-intl';
import { inject, toggleInject } from "../components/injector";

import icon from './image/icon_enter.png';



class FaultList extends React.PureComponent {

    componentDidMount() {
        document.title = this.props.intl.formatMessage({ id: 'faultTitle' })
    }

    render() {
        const { pwr, intl, history} = this.props;
        return (
            <ul className={style.onlineH5}>
                <li onClick={() => history.push('/error11')}><span>{intl.formatMessage({ id: 'error1' })}</span> <a><img src={icon} /></a></li>
                <li onClick={() => history.push('/error22')}><span>{intl.formatMessage({ id: 'error2' })} </span><a><img src={icon} /></a></li>
                <li onClick={() => history.push('/error33')}><span>{intl.formatMessage({ id: 'error3' })} </span><a><img src={icon} /></a></li>
                <li onClick={() => history.push('/error44')}><span>{intl.formatMessage({ id: 'error4' })}</span> <a><img src={icon} /></a></li>
                <li onClick={() => history.push('/error55')}><span>{intl.formatMessage({ id: 'error5' })} </span><a><img src={icon} /></a></li>
            </ul>
        )
    }
}



export default inject()(injectIntl(FaultList));